import Filter from "../filter";
import { initialState } from "../initialStates/create";
import FilterContainerComponent from "../../../components/rGlobalComponents/FilterContainerComponent";

const FilterContainer = ({ setQueryString, setIsFilter }) => {

    const handleFilterData = async (queryString) => {
        setQueryString(queryString)
        setIsFilter((prev) => !prev)
    }

    return (
        <FilterContainerComponent>
            <Filter model={initialState} handleFilterData={handleFilterData} />
        </FilterContainerComponent>
    )
}

export default FilterContainer;